import { AnimatedPageHeader } from '@components/index'
import FinanceDashboard from '@features/dashboard/components/FinanceDasboard'
import FlatDashboard from '@features/dashboard/components/FlatDashboard'
import UserActivity from '@features/dashboard/components/UserActivity'
import {
  useDashboardStatistics,
  useEndingLeases,
  useMessageAnalytics,
  useUnpaidRents
} from '@services/dashboard/queries'
import { useTranslation } from 'react-i18next'

import { EndingLeasesTable } from '../../components/EndingLeasesTable'
import { MessageAnalyticsTable } from '../../components/MessageAnalyticsTable'
import { UnpaidRentsTables } from '../../components/UnpaidRentsTables'

export function Dashboard() {
  const { t } = useTranslation('dashboard')

  const { data: statistics, isLoading: statsLoading } = useDashboardStatistics()
  const { data: analytics, isLoading: analyticsLoading } = useMessageAnalytics()
  const { data: rents, isLoading: rentsLoading } = useUnpaidRents()
  const { data: endingLeases, isLoading: endingLeasesLoading } =
    useEndingLeases()

  return (
    <div className="space-y-6">
      <AnimatedPageHeader title={t('title')} />

      <FinanceDashboard statistics={statistics} loading={statsLoading} />

      <EndingLeasesTable data={endingLeases} loading={endingLeasesLoading} />

      <div className="grid gap-6 xl:grid-cols-2">
        <UserActivity statistics={statistics} loading={statsLoading} />
        <FlatDashboard statistics={statistics} loading={statsLoading} />
      </div>

      <MessageAnalyticsTable analytics={analytics} loading={analyticsLoading} />

      <UnpaidRentsTables rents={rents} loading={rentsLoading} />
    </div>
  )
}
